import { ViewFilterChild, IViewFiltersData } from '@api'
import ChildFilters from './ChildFilters'
import ParentFilter from './ParentFilter'
type staticFilterProps = {
  isFiltered: boolean
  filters: ViewFilterChild[]
  viewFiltersData: IViewFiltersData
}
const DynamicFilters = ({ filters, isFiltered, viewFiltersData }: staticFilterProps) => {
  return (
    <div>
      {filters?.map(({ filterId, children }: ViewFilterChild, filtersIndex: number) => (
        <div key={filterId + filtersIndex}>
          {children.length ? (
            <ParentFilter isFiltered={isFiltered} id={filterId} viewFiltersData={viewFiltersData}>
              {children.map((id: string, childFilterIndex: number) => (
                <ChildFilters
                  key={id + childFilterIndex}
                  id={id}
                  viewFiltersData={viewFiltersData}
                />
              ))}
            </ParentFilter>
          ) : null}
        </div>
      ))}
    </div>
  )
}

export default DynamicFilters
